export const API_RESPONSE_ERROR_TEXT = {
  INSUFFICIENT_BALANCE: 'Insufficient balance'
}
